module.exports = __webpack_public_path__ + "static/vid-touch-control-8dfa736d62a454d80dee6bcb013292bd.mp4";